import { React, useState, useEffect, useRef } from 'react';
import Viz from 'components/Tableau/Viz';
import { useTranslation } from 'react-i18next';
import { callApi, getSessionItem } from 'utils/utils';
import { config } from 'utils/config';
import PageContent from 'layouts/PageContent';

const WTWVolumeDashboard = (props) => {
  const {t, i18n} = useTranslation(['salesPerformance', 'common']);
  const [viz, setViz] = useState(null);

  useEffect(() => {
    createViz();
  }, [])

  const createViz = () =>  {
    const paramsService = {};
    const urlWebService = `${config.UrlApiProject}Tableau/CheckIfUserIsWTWDeveloper?ClaUsuario=${getSessionItem('ClaUsuarioMod', 0)}`;

    callApi(urlWebService, 'GET', paramsService, (response) => {
        const params = {
          UserDeveloper: response.data ? 1 : 0
        };

        const url = 'https://tableau.deacero.com/#/views/WTWVolume2/Dashboard2'

        setViz(<Viz url={url} parameters={params}></Viz>);
    });
  }

  return (
    <PageContent title={t('salesPerformance:WTWVolumeDashboard')}>
      <div>{viz}</div>
    </PageContent>
  )
}

export default WTWVolumeDashboard;